import React from 'react'
// Components
import { SettingsItem } from '.'
import { nothing } from '$helper/functions/utils'

interface Props {
  text: string
  Icon: React.ComponentType<any>
  onClick: () => any
}

export function SettingsItemWithIcon({ text, Icon, onClick = nothing }: Props) {
  return (
    <SettingsItem
      text={text}
      secondaryContent={<Icon fill="#55A6FF" />}
      onClick={onClick}
    />
  )
}
